import axios from "../utiles/axios.util";

function apiGetShipMng(shipmnt_no) {
    return axios.get(`/api/v1/shipMng?shipmnt_no=${shipmnt_no}`);
}

function apiGetShipMngDetail() {
    return axios.get(`/api/v1/shipMng/detail`);
}

function apiPostShipMng(formData) {
    return axios.post("/api/v1/shipMng", formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
}

export { apiGetShipMng, apiGetShipMngDetail, apiPostShipMng };
